'use client';

import { PropsWithChildren, useEffect } from 'react';
import { SERVER_CATEGORY_TREE_DISPLAY_ID } from '../../constants';

const SCROLL_POSITION_KEY = 'category_tree_scroll_position';

export const ScrollSaver = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    const container = document.getElementById(SERVER_CATEGORY_TREE_DISPLAY_ID);
    if (!container) return;

    const savedPosition = sessionStorage.getItem(SCROLL_POSITION_KEY);
    if (savedPosition) {
      container.scrollTop = parseInt(savedPosition, 10);
    }

    const handleScroll = () => {
      sessionStorage.setItem(
        SCROLL_POSITION_KEY,
        container.scrollTop.toString(),
      );
    };

    container.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return children;
};
